import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

const api = axios.create({ baseURL: API_BASE_URL });

let landingsPromise = null;

/**
 * Páginas SEO por marca y ciudad: [{ type: 'marca'|'ciudad', slug, name, count, indexable }]
 * Se cachea la promesa para no repetir la llamada al navegar entre landings.
 */
const getLandings = () => {
  if (!landingsPromise) {
    landingsPromise = api.get('/api/seo/landings')
      .then(res => res.data)
      .catch(err => { landingsPromise = null; throw err; });
  }
  return landingsPromise;
};

const seoService = { getLandings };

export default seoService;
